import React from "react";
import {
  RadioGroupRHF,
  SelectRHF,
  TextFieldRHF,
} from "../../components/RHFWrappedComponents";
import { CategoryContainer } from "../../components/CategoryContainer";
import { isNumber } from "../../util/validator";
import {
  enrollmentStatusOptions,
  gradeLevelOptions,
  scholarshipPurposeOptions,
} from "../../data";

export function RequiredFields() {
  return (
    <>
      <CategoryContainer title="Tell us a bit about you">
        <TextFieldRHF
          name="demographics.age"
          textFieldLabel={"How old are you?"}
          rules={{
            required: "Age is required",
            validate: {
              isNumber: isNumber([1]),
            },
          }}
        />
        <SelectRHF
          name="academicInfo.currentSchool.gradeLevel"
          menuItemOptions={gradeLevelOptions.map((o) => {
            return { value: o };
          })}
          selectLabel="Current Grade Level"
          rules={{ required: "Current Grade Level is required" }}
        />

        <TextFieldRHF
          name="academicInfo.currentSchool.gpa"
          textFieldLabel="Your Cumulative GPA (4.0 scale)"
          rules={{
            required: "Your Cumulative GPA (4.0 scale) is required",
            validate: {
              isNumber: isNumber([0, 4], false),
            },
          }}
        />
      </CategoryContainer>
      <CategoryContainer title="Now tell us about your college plans">
        <SelectRHF
          name={"collegeInfo.scholarshipPurpose"}
          menuItemOptions={scholarshipPurposeOptions}
          selectLabel={"Desired Degree Level"}
          rules={{ required: "Desired Degree Level is required" }}
        />
        <RadioGroupRHF
          radioGroupOptions={enrollmentStatusOptions}
          groupLabel={"Current or Desired enrollment status"}
          name={"collegeInfo.enrollmentStatus"}
        />
      </CategoryContainer>
    </>
  );
}
